import React from "react";
import { AspectRatio, VisuallyHidden } from "@chakra-ui/react";
import { GradientHalfHero } from "components/hero";
import { FillImage } from "components/images";
import { useCdpIndustry } from "contexts/cdp-industry-context";
import Balancer from "react-wrap-balancer";

export function CdpIndustryHero() {
  const { industry } = useCdpIndustry();
  return (
    <GradientHalfHero
      variant={industry.color}
      breadcrumbs={[{ title: "Browse more industries", href: "/cdp-industries" }]}
      title={<Balancer>The ultimate guide to CDPs for {industry.name}</Balancer>}
      description={`Learn everything there is to know about CDPs in ${industry.name}, including global trends, key insights, use cases, how leading ${industry.pluralNoun} are leveraging personalization, and a framework for evaluating CDP vendors.`}
      demoButtonText="Talk to an expert"
      media={
        <>
          <AspectRatio
            ratio={1 / 1}
            boxSize="100%"
            minH="300px"
            maxW={{ base: "100%", sm: "450px", xl: "500px" }}
            borderRadius={{ base: "big", md: "bigger" }}
            overflow="hidden"
          >
            <FillImage priority {...industry.heroImage} />
          </AspectRatio>
          <VisuallyHidden>{industry.seoCopy}</VisuallyHidden>
        </>
      }
      pt={{ base: "smaller", md: "small" }}
    />
  );
}
